import { NativeStackScreenProps } from "@react-navigation/native-stack";
import {
  CheckoutInvoiceRootScreenParamList,
  CheckoutRootParamList,
} from "../../../../types";
import { useSaleControllerProvider } from "../../utils/sale-controller";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { InvoiceRootScreenContext } from "../CheckoutInvoiceRootScreen/context";
import { CardStyleInterpolators } from "@react-navigation/stack";
import { CheckoutInvoiceScreen } from "../CheckoutInvoiceScreen";

export type CheckoutInvoiceRootScreenProps = NativeStackScreenProps<
  CheckoutRootParamList,
  "CheckoutInvoiceRootScreen"
>;

export const CheckoutInvoiceRootScreen =
  ({}: CheckoutInvoiceRootScreenProps) => {
    const { sale } = useSaleControllerProvider();

    const Stack =
      createStackHeaderNavigator<CheckoutInvoiceRootScreenParamList>();

    if (!sale) {
      return null;
    }

    return (
      <InvoiceRootScreenContext.Provider value={{ sale }}>
        <Stack.Navigator
          screenOptions={{
            animationEnabled: true,
          }}
        >
          <Stack.Group
            screenOptions={{
              headerShown: true,
              headerLeft: () => <ModalCloseButton type="Cancel" />,
              cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
            }}
          >
            <Stack.Screen
              name="CheckoutInvoiceScreen"
              component={CheckoutInvoiceScreen}
            />
          </Stack.Group>
        </Stack.Navigator>
      </InvoiceRootScreenContext.Provider>
    );
  };
